<script setup lang="ts">
import { onMounted, ref } from "vue";
import {
  GetCultureName
} from '@/stores/SettingsStore.ts'
import {ChangeCulture, GetMenuCultures} from '@/api/Umbraco.ts'
import {GetCurrentContentId} from '@/stores/SettingsStore'
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'
import { Menu as KMenu } from "@progress/kendo-vue-layout";
import { useLogger } from 'vue-logger-plugin'
import { setStoreLogger } from '../logger.ts'
const logger = useLogger()
setStoreLogger(logger)


const newItems = ref<{ country: string; culture: string; render: string; items: any[] }[]>([]);
const currentCulture = ref<string>('EN-US')
const { locale } = useI18n()
const { t } = useI18n()

onMounted(async () => {
  currentCulture.value = await GetCultureName()

  if (currentCulture.value) {
    const cultureParts = currentCulture.value.split("-");
    const culture = cultureParts[0];
    const country = cultureParts[1];
    newItems.value.push({
      country: country,
      culture: culture.toUpperCase(),
      render: "itemRender1",
      items: [],
    });
  } else {
    newItems.value.push({
      country: "us",
      culture: "en",
      render: "itemRender1",
      items: [],
    });
  }
  const currentContentId = await GetCurrentContentId()
  GetMenuCultures(currentContentId).then((cultures) => {
    if (Array.isArray(cultures)) {
      newItems.value[0].items = cultures.map((culture) => {
      logger.debug('culture', culture)
        return {
          culture: culture.cultureName,
          displayName: t(`languages.${culture.cultureName.split('-')[0]}`),
          country: culture.countryCode,
          render: "itemRender2",
          items: []
        };
      });
    }
  });
})

watch(locale, (newLocale) => {
    setTimeout(() => {
      // This assumes US as fallback country if you don't have a full mapping
      const country = newLocale === 'fr' ? 'FR' : newLocale === 'de' ? 'DE' : 'US'
      currentCulture.value = `${newLocale.toUpperCase()}-${country}`

      // Ensure newItems array has at least one item
      if (newItems.value.length === 0) {
        newItems.value.push({
          country: country,
          culture: newLocale.toUpperCase(),
          render: "itemRender1",
          items: []
        });
      } else {
        newItems.value[0].country = country
        newItems.value[0].culture = newLocale.toUpperCase()

        if (newItems.value[0].items) {
          //re-map menu items when locale changes
          const langCodeMap = (code: string) => t(`languages.${code}`)
          newItems.value[0].items = newItems.value[0].items.map(item => ({
            ...item,
            displayName: langCodeMap(item.culture.split('-')[0])
          }))
        }
      }
    }, 0);
})

async function selectHandler(event: any) {
  const selectedCulture = event.item?.culture
  if (selectedCulture) {
    const newUrl = await ChangeCulture(selectedCulture)
    window.location.href = newUrl
  } else {
    console.warn('Missing culture or content ID')
  }
}




</script>


<template>
  <div class="culturePicker">
    <label class="block mb-2 text-sm font-medium text-gray-700">
      {{ t('labels.ChooseLanguage') }}:
    </label>
    <KMenu :items="newItems" @select="selectHandler">
        <template v-slot:itemRender1="{ props }">
          <div class="title">
            <flag :iso="props.item.country" /><span>{{ props.item.culture }}</span>
          </div>
        </template>
        <template v-slot:itemRender2="{ props }">
          {{ props.item.displayName }}
        </template>
      </KMenu>
  </div>
</template>

<style lang="scss" scoped>
.culturePicker {
  display: flex;
  flex-direction: column;
  width: 150px;

  :deep(.k-menu-link) {
    padding-inline: 0;
  }
}
</style>
